var _path, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChipStepperLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.72059C15.5 9.79728 15.1219 11.2836 14.4964 12.9444C13.8756 14.5926 13.0293 16.3658 12.1331 17.9991C11.2364 19.6332 10.2967 21.1143 9.4935 22.1805C9.09064 22.7153 8.73167 23.1329 8.43742 23.4116C8.28985 23.5514 8.17009 23.6451 8.0791 23.701C8.04212 23.7238 8.0161 23.7364 8 23.7433C7.98391 23.7364 7.95788 23.7238 7.9209 23.701C7.82991 23.6451 7.71015 23.5514 7.56258 23.4116C7.26833 23.1329 6.90936 22.7153 6.5065 22.1805C5.70327 21.1143 4.76361 19.6332 3.86691 17.9991C2.97066 16.3658 2.1244 14.5926 1.50362 12.9444C0.878088 11.2836 0.5 9.79728 0.5 8.72059C0.5 4.29124 3.88441 0.75 8 0.75C12.1156 0.75 15.5 4.29124 15.5 8.72059Z",
    fill: "white",
    stroke: "#A020FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99978,
    cy: 8.24392,
    r: 6.11111,
    fill: "#A020FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipStepperLocation);
export default __webpack_public_path__ + "static/media/ChipStepperLocation.8c2edf1d0b978de015881d0efc2ef09b.svg";
export { ForwardRef as ReactComponent };